import { InjectionToken } from '@angular/core'
import { UserManagerSettings } from 'oidc-client-ts'

export interface OIDCClientConfig {
  userManagerSettings: UserManagerSettings
  timeoutIntervalInMilliseconds: number
  outputOIDCDebugLogs: boolean
}

export const OIDC_CLIENT_CONFIG = new InjectionToken<OIDCClientConfig>('oidc-client-config')
